// extracted by mini-css-extract-plugin
module.exports = {"inspirationWrapper":"InspirationTab_inspirationWrapper__BP8Nl","product-listing__row":"InspirationTab_product-listing__row__62GFD","d-block":"InspirationTab_d-block__lmI2f"};